module.exports = __webpack_public_path__ + "assets/img/reminder-detail-1.165da0e5.png";